module.exports = __webpack_public_path__ + "img/card-slider-vital.3b897470.png";